import { Reveal } from "./Reveal";
import PillButton from "./PillButton";
import { WHATSAPP } from "../data/content";

export default function ClosingCTA() {
    return (
        <section
            data-testid="closing-cta"
            className="px-6 py-32 md:px-12 md:py-48"
            style={{ backgroundColor: "var(--bg-2)" }}
        >
            <div className="mx-auto max-w-3xl text-center">
                <Reveal>
                    <span className="eyebrow">Programare</span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2
                        className="mt-6 font-serif font-light leading-[1.02]"
                        style={{ fontSize: "clamp(2.4rem, 6vw, 5rem)" }}
                    >
                        Pregătită pentru
                        <br />
                        următoarea transformare?
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p
                        className="mx-auto mt-8 max-w-xl font-sans text-base leading-relaxed"
                        style={{ color: "var(--muted-foreground)" }}
                    >
                        Te așteptăm în salonul LadyArt din Fălticeni pentru o
                        experiență dedicată frumuseții și îngrijirii părului.
                    </p>
                </Reveal>
                <Reveal delay={0.24}>
                    <div className="mt-12 flex justify-center">
                        <PillButton
                            href={WHATSAPP}
                            external
                            variant="solid"
                            testId="closing-book-btn"
                        >
                            Programează-te
                        </PillButton>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
